<zdb-main-layout>
  <ng-container *ngIf="userIsDoctor$ | async as userIsDoctor; else organizationsNetwork">
    <zdb-patients-network></zdb-patients-network>
  </ng-container>
</zdb-main-layout>

<ng-template #organizationsNetwork>
  <zdb-organizations-network></zdb-organizations-network>
</ng-template>
